/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum HeatstackFeatureFlags {
    heat_2601_a_cost_rate_optimization = 'heat_2601_a_cost_rate_optimization',
    heat_2601_a_azure_aks_cluster = 'heat_2601_a_azure_aks_cluster',
    heat_2601_a_google_gke_cluster = 'heat_2601_a_google_gke_cluster',
    heat_2602_a_master_account_policy_config = 'heat_2602_a_master_account_policy_config',
    heat_2603_b_ai_observability_119985 = 'heat_2603_b_ai_observability_119985'
}
